<div class="back-to-list">
  <div class="navigation-left">
    <a class="arrow arrow-left" (click)="goBack()">{{ backToLabel }}</a>
  </div>
</div>

<mat-card>
  <form [formGroup]="form" (ngSubmit)="save()">
    <mat-card-content>
      <div>
        <mat-form-field appearance="outline">
          <mat-label translate="parameters/external-authorizations/details/name"></mat-label>
          <input type="text" matInput formControlName="name" />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label translate="parameters/external-authorizations/details/identifier"></mat-label>
          <input type="text" matInput formControlName="clientId" />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label
            [translate]="
              create
                ? 'parameters/external-authorizations/details/secret'
                : 'parameters/external-authorizations/details/modify-secret'
            "></mat-label>
          <input type="text" matInput formControlName="secret" />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label translate="parameters/external-authorizations/details/endpoint"></mat-label>
          <input type="text" matInput formControlName="endpoint" />
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline">
          <mat-label translate="parameters/external-authorizations/details/scope"></mat-label>
          <input type="text" matInput formControlName="scope" />
        </mat-form-field>
      </div>

      <div class="header" *ngFor="let control of headersArray.controls; let index = index; let first = first">
        <mat-form-field appearance="outline">
          <mat-label translate="parameters/external-authorizations/details/header/name"></mat-label>
          <input matInput [formControl]="$any(headersArray.controls[index].get('name'))" />
        </mat-form-field>
        <strong> &nbsp;=&nbsp; </strong>
        <mat-form-field appearance="outline">
          <mat-label translate="parameters/external-authorizations/details/header/value"></mat-label>
          <input matInput [formControl]="$any(headersArray.controls[index].get('value'))" />
        </mat-form-field>
        <mat-icon
          aria-label="delete an header"
          (click)="deleteHeader(index)"
          color="danger"
          class="action"
          *ngIf="!first || headersArray.controls.length > 1">
          delete
        </mat-icon>
      </div>
      <p>
        <button mat-icon-button type="button" aria-label="add an header" (click)="addHeader()">
          <mat-icon color="primary"> add_circle </mat-icon>
        </button>
      </p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="primary" translate="save" type="submit" [disabled]="form.invalid"></button>
      <button mat-raised-button translate="cancel" (click)="goBack()" type="button"></button>
    </mat-card-actions>
  </form>

  <app-card-footer [data]="footerContent"></app-card-footer>
</mat-card>
